import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_PURCHASER = gql`
  mutation CreateMasterDataPurchaser($params: CreateMasterDataPurchaserInput!) {
    createMasterDataPurchaser(params: $params) {
      purchaserId
      purchaserKey
      purchaserName
      isActive
      metadata
      searchKeywords
      defaultProductCategoryId
      defaultProductCategoryName
      intelligenceFilter
      discountPercentageCredit
      deductionTypeInvoicePatternForDiscount
      discountPercentageDeduction
      discountTermAgreementDays
      additionalFieldMapping
      discountTermAgreementDaysTolerance
      distributionCentersCount
    }
  }
`;

export const UPDATE_MASTER_DATA_PURCHASER = gql`
  mutation UpdateMasterDataPurchaser($params: UpdateMasterDataPurchaserInput!) {
    updateMasterDataPurchaser(params: $params) {
      purchaserId
      purchaserKey
      purchaserName
      isActive
      metadata
      searchKeywords
      defaultProductCategoryId
      defaultProductCategoryName
      intelligenceFilter
      discountPercentageCredit
      deductionTypeInvoicePatternForDiscount
      discountPercentageDeduction
      discountTermAgreementDays
      additionalFieldMapping
      discountTermAgreementDaysTolerance
      distributionCentersCount
    }
  }
`;
